<template>
	<div :class="{ header: true, hp_cz_center: true, 'sure-login': sureLogin }">
		<div class="hp_cz_center cursor-point" style="white-space:nowrap;">
			<img src="@/assets/index/logo.png" alt />
			<div @click="goIndex" class="logo cursor-point">
				<p>淮南智慧医疗</p>
				<p>HUAINAN SMART MEDICAL</p>
			</div>
		</div>
		<div style="margin-left:24px;">
			<a-menu v-model="current" @click="goOther" mode="horizontal">
				<a-menu-item v-for="item in navList" class :key="item.key">
					{{ item.title }}
				</a-menu-item>
			</a-menu>
		</div>
		<div v-if="sureLogin" class="hp_cz_center login-success">
			<a-input-search
				ref="userNameInput"
				v-model="keyWord"
				placeholder="请输入医院名/科室名/医生名"
				class="search-input"
				@search="onSearch"
			>
				<a-icon
					slot="prefix"
					type="search"
					@click="onSearch(keyWord)"
				/>
			</a-input-search>
			<a-badge :dot="msgCounts > 0" class="notification">
				<icon-font type="icon-icon" @click="goMsg" />
			</a-badge>
			<div class="user-img cursor-point">
				<!-- <img src="@/assets/default-img/r-doctor.png" alt /> -->
				<a-dropdown>
					<a
						class="ant-dropdown-link"
						@click="(e) => e.preventDefault()"
					>
						<img src="@/assets/default-img/r-doctor.png" alt />
					</a>
					<a-menu slot="overlay" @click="handleMenuClick">
						<a-menu-item @click="goNext" key="1"
							>个人中心</a-menu-item
						>
						<a-menu-item @click="logOut" key="2"
							>退出登录</a-menu-item
						>
					</a-menu>
				</a-dropdown>
			</div>
		</div>
		<div v-else class="hp_cz_center login">
			<span class="left" @click="toLogin">登录</span>
			<div class="line"></div>
			<span class="right" @click="toLogin">注册</span>
		</div>
	</div>
</template>
<script>
import { getDict, getBaseDepts } from '@/api/user'
import { message } from 'ant-design-vue'
import { logout } from '@/api/user'
import { getUnreadList } from '@/api/user-center'
import { ls } from '@/utils/tool'
import { removeToken } from '@/utils/auth'
import { getPcZndzUrl } from '@/api/index'
export default {
	inject: ['reload'],
	data() {
		return {
			sysUser: ls.get('sysUser'),
			current: ['/index'],
			navList: [
				{
					title: '首页',
					key: '/',
				},
				{
					title: '预约挂号',
					key: '/registered',
				},
				{
					title: '科室查找',
					key: '/office',
				},
				{
					title: '新闻公告',
					key: '/news-bulletin',
				},
				{
					title: '智能导诊',
					key: '/smart',
				},
				{
					title: '症状自查',
					key: '/check',
				},
			],
			keyWord: '',
			sureLogin: false,
			visible: false,
		}
	},
	watch: {
		$route() {
			if (this.$route.fullPath == '/') {
				this.current = ['/']
			}
			if (this.$route.path != '/search-result') {
				this.keyWord = ''
			}
		},
	},
	created() {
		this.getDicts()
		//模拟登录状态，手动添加login==true
		ls.get('sysUser') ? (this.sureLogin = true) : ''
		this.navList.forEach((item) => {
			if (this.$route.path.indexOf(item.key) != -1) {
				this.current[0] = item.key
			}
		})
		this.getMsgCount()

		console.log('this.$route.path=====', this.$store.state)
	},
	computed: {
		msgCounts() {
			return this.$store.state.msgCount
		},
	},
	methods: {
		toLogin() {
			this.$router.push('/login')
		},
		goIndex() {
			this.current = ['/']
			this.$router.push('/')
		},
		// 退出登录
		async logOut() {
			await logout()
			removeToken()
			ls.cl()
			this.$router.push('/')
			this.reload()
			//
			//   location.href = location.href;
		},
		handleMenuClick(e) {},
		goNext() {
			this.$router.push({
				path: '/user-center/personal-home',
				query: {},
			})
		},
		goMsg() {
			this.$router.push({
				path: '/user-center/news-center',
				query: {},
			})
		},
		async goOther({ item, key, keyPath }) {
			if (key == '/smart') {
				if (localStorage.getItem('token')) {
					let res = await getPcZndzUrl()
					if (res.code == 200) {
						this.$store.commit('showLoading')
            
						location.href = res.data
						setTimeout(() => {
							this.$store.commit('hideLoading')
						}, 3000)
					}
					return
				}
				this.$message.warning('请登录后再点击!')
				return
			}
			this.$router.push({
				path: key,
				query: {},
			})
		},
		onSearch(value) {
			console.log(value, !value)
			if (!value) {
				message.warning('请先输入搜索内容！')
				return
			}
			this.$router.push({
				path: '/search-result',
				query: {
					keyWord: value,
				},
			})
		},
		async getMsgCount() {
			if (!localStorage.getItem('sysUser')) return
			let data = {
				memberId: JSON.parse(localStorage.getItem('sysUser')).id,
			}
			let re = await getUnreadList(data)
			this.$store.commit('changeMsgCount', re.data)
		},
		async getDicts() {
			var HOSP_LEVEL = await getDict({ type: 'HOSP_LEVEL' })
			var HOSP_TYPE = await getDict({ type: 'HOSP_TYPE' })
			var HOSP_ADMIN = await getDict({ type: 'HOSP_ADMIN' })
			var baseDepts = await getBaseDepts()
			ls.set('HOSP_LEVEL', HOSP_LEVEL.data)
			ls.set('HOSP_TYPE', HOSP_TYPE.data)
			ls.set('HOSP_ADMIN', HOSP_ADMIN.data)
			ls.set('baseDepts', baseDepts.data)
		},
	},
	mounted() {},
}
</script>
<style lang="less" scoped>
.header {
	justify-content: space-between;
	width: 1200px;
	height: 88px;
	margin: 0 auto;
	img {
		width: 47px;
		height: 52px;
	}
	.logo {
		p {
			font-family: Source Han Sans SC;
			font-weight: 500;
			color: #000000;
			margin: 0;
		}
		p:first-child {
			font-size: 22px;
			line-height: 1;
			margin-bottom: 6px;
		}
		p:nth-child(2) {
			font-size: 12px;
			line-height: 1;
		}
	}

	.ant-menu-horizontal {
		border: none;
	}
	.ant-menu-item {
		font-size: 18px;
		padding: 0 15px !important;
	}
	.ant-menu-item-selected {
		color: #466daf;
		border-bottom: 2px solid #466daf;
	}
	.ant-menu-item-active {
		color: #466daf;
		border-bottom: 2px solid #466daf;
	}
	.login {
		margin-left: 40px;
		.left {
			font-size: 20px;
			color: #466daf;
		}
		.line {
			width: 2px;
			height: 20px;
			background: #f3f3f3;
			margin: 0 11px;
		}
		.right {
			font-size: 20px;
			font-weight: 400;
			color: #999999;
		}
		span {
			cursor: pointer;
		}
	}
	.login-success {
		.search-input {
			font-size: 14px;
			font-weight: 400;
			color: #999999;
			/deep/ .ant-input {
				width: 371px;
				height: 38px;
				background: #eaeaea;
				border-radius: 19px;
				padding-left: 60px;
			}
			/deep/ .ant-input-prefix {
				font-size: 19px;
				color: #999999;
				margin-left: 13px;
				margin-right: 13px;
			}
		}
		.notification {
			font-size: 28px;
			margin: 0 25px;
			color: #999;
		}
		.user-img {
			width: 45px;
			height: 45px;
			img {
				width: 45px;
				height: 45px;
			}
		}
	}
	/deep/ .ant-input-suffix {
		display: none;
	}
}
.sure-login {
	.ant-menu-item {
		font-size: 18px;
		padding: 0 20px;
	}
	.logo {
		p:first-child {
			font-size: 22px;
			line-height: 1;
			margin-bottom: 7px;
		}
		p:nth-child(2) {
			font-size: 12px;
			line-height: 1;
		}
	}
	.ant-menu-item-selected {
		color: #3385ed;
		border-bottom: none;
	}
	.ant-menu-horizontal > .ant-menu-item:hover {
		border-bottom: none;
	}
	.ant-menu-horizontal > .ant-menu-item {
		border-bottom: none;
	}

	.ant-menu-item-active {
		color: #3385ed;
		border-bottom: none;
	}
	.ant-menu-submenu {
		border-bottom: none;
	}
}
</style>
